<template lang='pug'>
	v-chip.v-chip--label-custom( label v-bind="chipProps" @click='handleClick' ) {{ value }}
</template>

<script>
	//
	export default {
	    computed: {

	        /**
	         * @description
	         * Vuetify chips props
	         *
	         * @return  {Object}    Vuetify chip object props
	         */
	        chipProps() {
	            return {
	                ...this.$attrs,
	                color: this.chipColor,
	                style: this.chipStyle,
	            }
	        },

	        /**
	         * @description
	         * Vuetify chip color
	         *
	         * @return  {String}    Vuetify chip color name
	         */
	        chipColor() {
	            return this.palette[this.valueKey] || this.$attrs.color || ''
	        },

	        /**
	         * @description
	         * Vuetify chip style
	         *
	         * @return  {String}    Vuetify chip style rules
	         */
	        chipStyle() {
	            return {
	            	pointerEvents: this.noEvents ? 'none' : '',
	            	textDecoration: this.hasRouteValue ? 'underline' : '',
	            	cursor: this.hasRouteValue ? 'pointer !important' : '',
	            }
	        },

	        hasRouteValue() {
	        	return this.item && this.routeValue && this.item[this.routeValue]
	        },

	        /**
	         * @description
	         * Palette enum key
	         *
	         * @return  {String}    Palette enum key string
	         */
	        valueKey() {
	            return this.value
	                .toString()
	                .toLowerCase()
	                .split(' ')
	                .join('_')
	        },
	    },
	    methods: {
	    	handleClick() {

	            //
	            const hasRoute = this.item.hasOwnProperty(this.routeValue)

	            //
	            if (this.item[this.routeValue]) {
	                this.$router.push({ 
	                    name: this.routeName, 
	                    params: { 
	                        [this.routeParam]: this.item[this.routeValue]
	                    } 
	                })
	            }
	        },
	    },
	    props: {

	        /**
	         * { item_description }
	         */
	        item: {
	            type: Object,
	            default: () => ({}),
	        },

	        /**
	         * @description
	         * Disable chip events flag
	         */
	        noEvents: Boolean,

	        /**
	         * @description
	         * Enum of available colors
	         */
	        palette: {
	            type: Object,
	            default: () => ({}),
	        },

	        
	        routeName: String,
	        routeParam: String,
	        routeValue: String,

	        /**
	         * @description
	         * Palette enum key
	         */
	        value: {
	            type: String,
	            default: '',
	        },
	    },
	}
</script>


<style>
	.v-chip.v-chip--label-custom .v-chip__content  {
		cursor: inherit !important;
	}
<style>